import { Route } from "react-router-dom"
import React from "react"
import { LEGAL_CONST, KAIZEN_HUB_ROUTE } from "../constants"
import TC from "../termsAndConditionsState"

import PrivacyPolicy from "../sections/privacy-policy"
import SupportPolicy from "../sections/support-policy"
import AcceptableUsePolicy from "../sections/acceptable-use-policy"
import DataProcessingAddendum from "../sections/data-processing-addendum"
import TermsAndConditions from "../sections/terms-and-conditions"
import { ModuleTC, OutstandingTC } from "../types"

export default ({ tcManager }: { tcManager: TC }) => {
  const hubPage = TC.cleanUrl(`/${LEGAL_CONST}/${KAIZEN_HUB_ROUTE}`)
  return (
    <>
      <Route path={`${hubPage}/privacy-policy`}>
        <PrivacyPolicy page={hubPage} />
      </Route>
      <Route path={`${hubPage}/support-policy`}>
        <SupportPolicy />
      </Route>
      <Route path={`${hubPage}/acceptable-use-policy`}>
        <AcceptableUsePolicy />
      </Route>
      <Route path={`${hubPage}/data-processing-addendum`}>
        <DataProcessingAddendum />
      </Route>
      <Route exact path={`${hubPage}/terms-and-conditions`}>
        <TermsAndConditions
          module={tcManager.hubModule}
          tcManager={tcManager}
        />
      </Route>
      {tcManager.nonHubThemeModules.map((module: OutstandingTC) => (
        <Route
          key={`${module}-nonHubThemeModules`}
          exact
          path={TC.cleanUrl(
            `/${LEGAL_CONST}/${module.name}/terms-and-conditions`
          )}
        >
          <TermsAndConditions module={module} tcManager={tcManager} />
        </Route>
      ))}
      {tcManager.nonThemeModules.map((module: ModuleTC) => (
        <Route
          key={`${module.name}-nonThemeModules`}
          exact
          path={TC.cleanUrl(`${hubPage}/${module.name}`)}
        >
          <TermsAndConditions module={[module]} tcManager={tcManager} />
        </Route>
      ))}
      {tcManager.linklaters.map((module: ModuleTC) => (
        <Route
          key={`${module}-linklaters`}
          exact
          path={TC.cleanUrl(
            `/${LEGAL_CONST}/${module.name}/terms-and-conditions`
          )}
        >
          <TermsAndConditions module={[module]} tcManager={tcManager} />
        </Route>
      ))}
    </>
  )
}
